export { default as DefaultPage } from './DefaultPage';
export { default as Header1 } from './common/header/Header1';
export { default as Header2 } from './common/header/Header2';
export { default as Footer2 } from './common/footer/Footer2';
export { default as SearchBox1 } from './common/search-box/SearchBox1';
export { default as ContactForm1 } from './common/contact/ContactForm1';
export { default as OfficesList } from './common/OfficeList/OfficesList';
export { default as AboutUs1 } from './common/about-us/AboutUs1';
export { default as AboutUsIconSection } from './common/about-us/AboutUsIconSection';
export { default as ContactBy } from './common/contactBy/ContactBy';
export { default as StartPopup } from './common/popup/StartPopup';
export { default as Theme3 } from './theme3/Theme3';
export { default as Header3 } from './common/header/Header3';
export { default as Footer } from './common/footer/Footer';
export { default as SearchBox2 } from './common/search-box/SearchBox2';
export { default as ContactForm3 } from './common/contact/ContactForm3';
export { default as Footer3 } from './common/footer/Footer3';
export { default as Header5 } from './common/header/Header5';
export { default as Footer5 } from './common/footer/Footer5';
export { default as Service1 } from './common/Services/Service1';
export { default as ContactForm2 } from './common/contact/ContactForm2';

// -------------------------------
export { default as ThemeFiveSearchBox } from './theme5/components/ThemeFiveSearchBox';
export { default as ThemeFiveTitles } from './theme5/components/ThemeFiveTitles';
export { default as ThemeFiveSlider } from './theme5/components/ThemeFiveSlider';
export { default as ThemeFiveContactForm } from './theme5/components/ThemeFiveContactForm';
export { default as ThemeFiveIconsSection } from './theme5/components/ThemeFiveIconsSection';
export { default as ThemeFiveOfficeSection } from './ThemeFiveOfficeSection';
export { default as ThemeFiveFleetSection } from './theme5/components/ThemeFiveFleetSection';

// ThemeTwo
export { default as ThemeTwoHeader } from './ThemeTwo/common/ThemeTwoHeader';
export { default as ThemeTwoSearchBox } from './ThemeTwo/common/ThemeTwoSearchBox';
export { default as ThemeTwoTitle } from './ThemeTwo/common/ThemeTwoTitle';
export { default as ThemeTwoSlider } from './ThemeTwo/common/ThemeTwoSlider';
export { default as ThemeTwoIconsSection } from './ThemeTwo/common/ThemeTwoIconsSection';
export { default as ThemeTwoTnCSection } from './ThemeTwo/common/ThemeTwoTnCSection';
export { default as ThemeTwoContactSection } from './ThemeTwo/common/ThemeTwoContactSection';
export { default as ThemeTwoOfficeSection } from './ThemeTwo/common/ThemeTwoOfficeSection';
export { default as ThemeTwoPopup } from './ThemeTwo/common/ThemeTwoPopup';
export { default as ThemeTwoAboutUs } from './ThemeTwo/common/ThemeTwoAboutUs';
export { default as HomeBanners } from './HomeBanners';

// ThemeFour
export { default as ThemeFourHeader } from './ThemeFour/common/ThemeFourHeader';
export { default as ThemeFourFooter } from './ThemeFour/common/ThemeFourFooter';
export { default as ThemeFourSearchBox } from './ThemeFour/common/ThemeFourSearchBox';
export { default as ThemeFourIconSection } from './ThemeFour/common/ThemeFourIconSection';
export { default as ThemeFourSlider } from './ThemeFour/common/ThemeFourSlider';
export { default as ThemeFourTitle } from './ThemeFour/common/ThemeFourTitle';
export { default as ThemeFourContactForm } from './ThemeFour/common/ThemeFourContactForm';
export { default as ThemeFourOfficeSection } from './ThemeFour/common/ThemeFourOfficeSection';
export { default as ThemeFourAboutIconSection } from './ThemeFour/common/ThemeFourAboutIconSection';
// ThemeThree
export { default as ThemeThreeHeader } from './ThemeThree/common/ThemeThreeHeader';
export { default as ThemeThreeSearchBox } from './ThemeThree/common/ThemeThreeSearchBox';
export { default as ThemeThreeTitle } from './ThemeThree/common/ThemeThreeTitle';
export { default as ThemeThreeIconsSection } from './ThemeThree/common/ThemeThreeIconsSection';
export { default as ThemeThreeSlider } from './ThemeThree/common/ThemeThreeSlider';
export { default as ThemeThreeContactForm } from './ThemeThree/common/ThemeThreeContactForm';
export { default as ThemeThreeFooter } from './ThemeThree/common/ThemeThreeFooter';

// ThemeSeven
export { default as ThemeSevenHeader } from './ThemeSeven/common/ThemeSevenHeader';
export { default as ThemeSevenFooter } from './ThemeSeven/common/ThemeSevenFooter';
export { default as ThemeSevenBanner } from './ThemeSeven/common/ThemeSevenBanner';
export { default as ThemeSevenSearchBox } from './ThemeSeven/common/ThemeSevenSearchBox';
export { default as ThemeSevenSlider } from './ThemeSeven/common/ThemeSevenSlider';

// pages]
export { default as ThemeSevenTnCScreen } from './ThemeSeven/ThemeSevenPages/ThemeSevenTnCScreen';
export { default as ThemeSevenCargoScreen } from './ThemeSeven/ThemeSevenPages/ThemeSevenCargoScreen';
export { default as ThemeSevenSpecialServicesScreen } from './ThemeSeven/ThemeSevenPages/ThemeSevenSpecialServicesScreen';
export { default as ThemeSevenPriceAndServicesScreen } from './ThemeSeven/ThemeSevenPages/ThemeSevenPriceAndServicesScreen';
export { default as ThemeSevenAboutUsScreen } from './ThemeSeven/ThemeSevenPages/ThemeSevenAboutUsScreen';
export { default as ThemeSevenFrequentCard } from './ThemeSeven/ThemeSevenPages/ThemeSevenFrequentCard';
export { default as ThemeSevenContactScreen } from './ThemeSeven/ThemeSevenPages/ThemeSevenContactScreen';
export { default as ThemeSevenCompanyScreen } from './ThemeSeven/ThemeSevenPages/ThemeSevenCompanyScreen';
export { default as ThemeSevenGalleryScreen } from './ThemeSeven/ThemeSevenPages/ThemeSevenGalleryScreen';
export { default as ThemeSevenTicketSaleScreen } from './ThemeSeven/ThemeSevenPages/ThemeSevenTicketSaleScreen';
export { default as ThemePopup } from './common/ThemePopup';

// ThemeEigth
export { default as ThemeEightHeader } from './ThemeEight/common/ThemeEightHeader';
export { default as ThemeEightSearchBox } from './ThemeEight/common/ThemeEightSearchBox';
export { default as ThemeEightFooter } from './ThemeEight/common/ThemeEightFooter';
export { default as ThemeEightContactUsScreen } from './ThemeEight/ThemeEightPages/ThemeEightContactUsScreen';

// ThemeNine
export { default as ThemeNineCompanyScreen } from './ThemeNine/ThemeNinePages/ThemeNineCompanyScreen';
export { default as ThemeNineContactScreen } from './ThemeNine/ThemeNinePages/ThemeNineContactScreen';
export { default as ThemeNineWorkWithUs } from './ThemeNine/ThemeNinePages/ThemeNineWorkWithUs';
export { default as ThemeNineMendozaTnCScreen } from './ThemeNine/ThemeNinePages/ThemeNineMendozaTnCScreen';
export { default as ThemeNineRegulationTnCScreen } from './ThemeNine/ThemeNinePages/ThemeNineRegulationTnCScreen';
export { default as ThemeNineBaggageTnCScreen } from './ThemeNine/ThemeNinePages/ThemeNineBaggageTnCScreen';
export { default as ThemeNineOfficeScreen } from './ThemeNine/ThemeNinePages/ThemeNineOfficeScreen';
export { default as ThemeNineFrequentPassengersScreen } from './ThemeNine/ThemeNinePages/ThemeNineFrequentPassengersScreen'
export { default as ThemeNineSpecialServicesScreen } from './ThemeNine/ThemeNinePages/ThemeNineSpecialServicesScreen'
export { default as ThemeEightPrivacyPolicy } from './ThemeEight/ThemeEightPages/ThemeEightPrivacyPolicy';
export { default as ThemeTenTitle } from './ThemeTen/components/ThemeTenTitle';
export { default as ThemeTenSearchBox } from './ThemeTen/components/ThemeTenSearchBox';

export { default as Faqs } from './Faqs';
export { default as ThemeElevenFooter } from './ThemeEleven/components/ThemeElevenFooter';
export { default as ThemeElevenHeader } from './ThemeEleven/components/ThemeElevenHeader';
export { default as ThemeElevenTitle } from './ThemeEleven/components/ThemeElevenTitle';
export { default as ThemeElevenCompanyScreen } from './ThemeEleven/pages/ThemeElevenCompanyScreen';
export { default as ThemeElevenTerminalSur } from './ThemeEleven/pages/ThemeElevenTerminalSur';
export { default as ThemeElevenPajatiros } from './ThemeEleven/pages/ThemeElevenPajatiros';
export { default as ThemeElevenLos } from './ThemeEleven/pages/ThemeElevenLos';
export { default as ThemeElevenMaipu } from './ThemeEleven/pages/ThemeElevenMaipu';
export { default as ThemeElevenFaq } from './ThemeEleven/pages/ThemeElevenFaq';
export { default as ThemeElevenContact } from './ThemeEleven/pages/ThemeElevenContact';
export { default as ThemeElevenSearchBox } from './ThemeEleven/components/ThemeElevenSearchBox';



// WEBPACK FOOTER //
// ./src/features/themes/index.js